import * as React from 'react';
import { WidgetProps, ComponentProps } from '@intermix-dashboard/core';
import { withDownload } from './withDownload';
import { useThemeObserver } from '../hooks/useThemeObserver';
const Line = withDownload(
  React.lazy(() =>
    import('react-chartjs-2').then((module) => ({ default: module.Line }))
  )
);

export const IntermixLineChartComponent: React.FC<ComponentProps> = ({
  data,
}) => {
  const { display } = useThemeObserver();
  return (
    <React.Suspense fallback="loading...">
      {display && <Line data={data.rows} />}
    </React.Suspense>
  );
};

export const IntermixLineChartWidget: WidgetProps = {
  id: 'line-chart-widget',
  component: IntermixLineChartComponent,
  options: { w: 4, h: 3 },
};
